import React from 'react'

const Dashboard = () => {
  return (
    <React.Fragment>
        Dashboard
    </React.Fragment>
  )
}

export default Dashboard